import { SelectionModel } from '@angular/cdk/collections';
import { Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges, ViewChild } from '@angular/core';
import { MatCheckbox } from '@angular/material/checkbox';
import { MatMenuTrigger } from '@angular/material/menu';
import { MatTableDataSource } from '@angular/material/table';
import { SelectedRow } from '@app/models/selectedRow';
import * as moment from "moment";
import { Observable, filter, tap } from 'rxjs';
import { Store, select } from '@ngrx/store'
import { LimitAccessService } from '@app/core/services/limit-access.service';
import { selectCoreState } from '@app/core/store/core.selectors';

@Component({
  selector: 'app-standard-table',
  templateUrl: './standard-table.component.html',
  styleUrls: ['./standard-table.component.scss']
})
export class StandardTableComponent implements OnInit, OnChanges {
  public selection = new SelectionModel<any>(true, []);
  public selectedRow;
  public selectedRowId: number = 0;
  public isHandset$: boolean = false;
  public page$: number = 0;
  public total: number = 0;
  public pageSizeOptions: number[] = [5, 10, 25, 100]
  public currentPage :number = 0;
  public search = '';
  public filterLocations: boolean = false;
  public show_location: boolean;

  @Input() isChecked;
  @Input() displayedColumns;
  @Input() dataSource;
  @Input() totalRecords$: Observable<number>;
  @Input() rowMenuItems;
  @Input() totalDataSource;
  @Input() locationList;
  @Input() selectedLocation;
  @Input() editFinalizeOption;
  
  @Output() onRowClickedEvent = new EventEmitter<any>(true);
  @Output() onCheckboxChangeEvent = new EventEmitter<any>(true);
  @Output() onDetailsEvent = new EventEmitter<any>(true);
  @Output() onSortEvent = new EventEmitter<any>(true);
  @Output() onClearSearchEvent = new EventEmitter<any>(true);
  @Output() onSearchEvent = new EventEmitter<any>(true);
  @Output() onPageEvent = new EventEmitter<any>(true);
  @Output() onLoadFinalized = new EventEmitter<any>(true);
  
  @ViewChild('masterCheckbox') masterCheckbox: MatCheckbox
  @ViewChild('rowMenuTrigger') rowMenuTrigger: MatMenuTrigger;
  @ViewChild(MatMenuTrigger)

  public contextMenu: MatMenuTrigger;
  public contextMenuPosition = { x: '0px', y: '0px' };
  public searchInput: string = '';
  public sort: { active: string, direction: string } = { active: 'invBatchName', direction: 'asc'}

  constructor(
    private store$: Store<Store>,
    private limitAccessService: LimitAccessService
  ) { 
    this.dataSource = new MatTableDataSource(this.dataSource);
  }

  ngOnInit(): void {

    this.store$
    .select(selectCoreState)
    .pipe(
      filter((res) => res !== undefined && res !== null), 
      tap((res) => {
        this.show_location = res.show_location;
      })
    ).subscribe();

    this.limitAccessService.arraySettingAccess$.subscribe((arraySettingAccess) => {
      if (arraySettingAccess) {
        this.filterLocations = this.limitAccessService.getAccess('counts', 'finalized', 'filter_locations','');
      }
    });
    this.totalRecords$.subscribe((total) => {
      this.total = total;
    });
  }

  onSort(event){
    this.sort = event;
    this.onSortEvent.emit({ active: event.active, direction: event.direction, locations: this.selectedLocation });
  }

  onSearch(event){
    let searchTerm; 
    if (!event || !event.target || event.target.value === undefined || event.target.value === null) {
      searchTerm = this.search;
    }else{
      searchTerm = event.target.value;
    }

    if (searchTerm.length > 2) {
      this.onSearchEvent.emit({ query: searchTerm, active: this.sort.active, direction: this.sort.direction, locations: this.selectedLocation });
    }

    if (searchTerm == "") {
      this.onLoadFinalized.emit({locations: this.selectedLocation});
    }
  }

  onSelectionChange(event){
    this.onSearch(event);
  }

  onClearSearch(){
    this.searchInput = '';
    this.onClearSearchEvent.emit({locations: this.selectedLocation});
  }

  onPage(event){
    this.onPageEvent.emit({ event, locations: this.selectedLocation });
  }

  ngOnChanges(changes: SimpleChanges): void {
    if(this.selection.selected.length === 0){
    }
  }

  toggleAllRows() {
    if (this.isAllSelected()) {
      this.selection.clear();
      this.onCheckboxChangeEvent.emit([]);
      return;
    }

    this.selection.select(...this.dataSource);
    const selected = this.selection.selected.map(row => row.invID);
    this.onCheckboxChangeEvent.emit(selected);
  }

  onCheckboxToggle(row, event){
    event.stopPropagation();
    this.selection.toggle(row);
    const selected = this.selection.selected.map(item => item.invID);
    this.onCheckboxChangeEvent.emit(selected);
  }

  onCheckboxToggleChild(row){
    this.selection.toggle(row);
    const selected = this.selection.selected.map(item => item.invID);
    this.onCheckboxChangeEvent.emit(selected);
  }

  onMoment(time){
    return time //moment(time).format('MMMM Do YYYY, h:mm a');
  }

  onRowClicked(event, row){
    event.preventDefault();
    this.contextMenuPosition.x = event.clientX + 'px';
    this.contextMenuPosition.y = event.clientY + 'px';
    this.contextMenu.menu.focusFirstItem('mouse');
    this.contextMenu.openMenu();
    this.selectedRow = row;
  }

  onEditEvent(){

  }

  onDetailEvent(){

  }

  onDeleteEvent(){

  }

  isAllSelected(): boolean {
    const numSelected = this.selection.selected.length;
    const numRows = this.dataSource.length;
    return numSelected === numRows;
  }

}
